import { render, staticRenderFns } from "./TabelaErro.vue?vue&type=template&id=38a174de&scoped=true"
import script from "./TabelaErro.vue?vue&type=script&lang=js"
export * from "./TabelaErro.vue?vue&type=script&lang=js"
import style0 from "./TabelaErro.vue?vue&type=style&index=0&id=38a174de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a174de",
  null
  
)

export default component.exports